module.exports = __webpack_public_path__ + "static/media/privacy.82f78320.png";